import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, debounce, Tooltip } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useState, useLayoutEffect } from "react";
export const SymbolFlags = (props) => {
    const { symbolFlags, maxSymbols, onSeeMoreClick, style } = props;
    const [maxSymbolsCalculated, setMaxSymbolsCalculated] = useState(maxSymbols);
    useLayoutEffect(() => {
        let isMounted = true;
        const symbolFlagsWraps = document.querySelectorAll(".symbol-flags");
        const handleResize = debounce((entries) => {
            try {
                if (isMounted) {
                    entries.forEach((entry) => {
                        const documentRemToPxValue = parseFloat(getComputedStyle(document.documentElement).fontSize);
                        const dimensionIntValue = parseInt(dimension.replace("rem", ""));
                        const dimensionPxValue = documentRemToPxValue * dimensionIntValue + 2;
                        const { width } = entry.contentRect;
                        setMaxSymbolsCalculated(Math.floor(width / dimensionPxValue));
                    });
                }
            }
            catch (error) {
                console.error("Error in Symbol Flag ResizeObserver callback:", error);
            }
        }, 50);
        const symbolWrapObserver = new ResizeObserver(handleResize);
        if (symbolFlagsWraps.length) {
            symbolFlagsWraps.forEach((symbolFlagsWrap) => {
                symbolWrapObserver.observe(symbolFlagsWrap);
            });
        }
        return () => {
            isMounted = false;
            symbolWrapObserver.disconnect();
        };
    }, []);
    const dimension = "2rem";
    const enforceMax = symbolFlags && symbolFlags.length > maxSymbolsCalculated;
    let reachedMax = false;
    return (_jsx(_Fragment, { children: _jsx(Stack, Object.assign({ direction: "row", alignItems: "center", justifyContent: "left", flexWrap: "wrap", width: "100%", maxHeight: dimension, overflow: "hidden", style: Object.assign({}, style), className: "symbol-flags" }, { children: symbolFlags
                .sort((a, b) => a.Sequence - b.Sequence)
                .map((symbol, index) => {
                if (reachedMax) {
                    return;
                }
                const elemKey = `${symbol.FlagName}-${symbol.FlagValue}`;
                if (enforceMax && index == maxSymbolsCalculated - 1) {
                    const remainingSymbols = symbolFlags.length - maxSymbolsCalculated + 1;
                    reachedMax = true;
                    return (_jsxs(Box, Object.assign({ onClick: onSeeMoreClick, style: {
                            height: dimension,
                            width: dimension,
                            backgroundColor: "rgba(128,128,128,.2)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "50%",
                            marginRight: "2px",
                            cursor: "pointer",
                        } }, { children: ["+", remainingSymbols] }), elemKey));
                }
                else {
                    return symbol.Icon ? (_jsx(Tooltip, Object.assign({ title: symbol.Description }, { children: _jsx(Box, Object.assign({ style: {
                                marginRight: "2px",
                                width: dimension,
                                height: dimension,
                                display: "flex",
                            } }, { children: _jsxs("span", Object.assign({ className: "fa-stack" }, { children: [_jsx("i", { className: "fas fa-circle fa-stack-2x", style: { color: symbol.Color } }), _jsx("i", { className: symbol.Icon + " fa-stack-1x", style: { color: "white" } })] })) })) }), elemKey)) : (_jsx(Tooltip, Object.assign({ title: symbol.Description }, { children: _jsx(Box, Object.assign({ style: {
                                height: dimension,
                                width: dimension,
                                backgroundColor: symbol.Color,
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "50%",
                                marginRight: "2px",
                                fontWeight: "bold",
                                fontSize: "60%",
                            } }, { children: symbol.Abbreviation })) }), elemKey));
                }
            }) })) }));
};
